import { IComponentOptions, IController, ITimeoutService } from 'angular';
import { StateService } from '@uirouter/angularjs';
import { MailboxService } from '../../services';
import { MailboxQuery } from '../../shared/mailbox-query';
import { IMailboxPageData } from '../../shared/mailbox-page-data.interface';
import { Mail } from '../../shared/mail';
import { ToastrService } from '../../../../core/services/toastr/toastr.service';
import { IMailsGroupByDate } from '../../shared/mails-by-date.interface';
import './mailbox-page.component.scss';

class MailboxController implements IController {
  static $inject = ['$state', 'MailboxService', 'ToastrService', '$timeout'];
  pages: number = 0;
  count: number = 0;
  query: MailboxQuery;
  loading: boolean;
  mailsGroupByDate: IMailsGroupByDate[];
  mails: Mail[];
  selectedMailsIds: string[] = [];
  selected: 'all' | 'mixed' | 'none';
  checkedAll: boolean = false;
  isMobile: boolean = false;

  constructor(
    private $state: StateService,
    private mailboxService: MailboxService,
    private toastrService: ToastrService,
    private $timeout: ITimeoutService
  ) {}

  $onInit() {
    this.isMobile = window.innerWidth < 800 ? true : false;
    this.query = new MailboxQuery();
    this.initialQueryConfig();
    this.loadMails();
  }

  onCheck(event) {
    if (event.check) {
      this.selectedMailsIds.push(event.selected);
    } else {
      this.selectedMailsIds.splice(
        this.selectedMailsIds.indexOf(event.selected),
        1
      );
    }
  }

  onSelectPartClick() {
    console.log('part');
    // this.allSelected = false;
    // this.$timeout(() => {
    // this.partSelected = true;
    this.selected = 'mixed';
    // });
  }

  onUpdate() {
    this.loadMails();
  }

  onPageSelect(event: { page: number }) {
    this.checkedAll = false;
    this.selectedMailsIds = [];
    const page = event.page;
    if (page !== this.query.page) {
      this.query.page = page;
      this.loadMails();
    }
  }

  checkAll() {
    this.checkedAll = !this.checkedAll;
  }

  deleteAll() {
    this.mailboxService.deleteMail(this.selectedMailsIds).then((res) => {
      this.loadMails();
      this.checkedAll = false;
    });
  }

  onOpen(id) {
    const mails = this.mails.map((mail: Mail) => {
      if (mail._id === id && !mail.is_open) {
        return { ...mail, is_open: true };
      }
      return {
        ...mail,
        is_open: false
      };
    });
    this.mails = mails;
    this.mailsGroupByDate = this.mailboxService.groupMailsByDate(mails);
  }

  private loadMails() {
    this.mailboxService
      .getMails(this.query)
      .then((mailsData) => {
        this.mails = mailsData.mails;
        this.mailsGroupByDate = this.mailboxService.groupMailsByDate(
          mailsData.mails
        );
        this.pages = mailsData.pages;
        this.count = mailsData.count;
      })
      .catch((err) => {
        console.log(err);
        this.toastrService.error(
          JSON.stringify(err.data || 'Unknown Error'),
          'Error'
        );
      });
  }

  private initialQueryConfig() {
    const routeData = (this.$state.current.data || {}) as IMailboxPageData;
    this.query.type = routeData.filter;
    this.query.important = routeData.important;
    this.query.limit = 10;
    this.query.page = 1;
  }
}

export const MailboxPageComponent: IComponentOptions = {
  controller: MailboxController,
  template: require('./mailbox-page.component.html'),
  bindings: {}
};



// WEBPACK FOOTER //
// ./app/states/mailbox/pages/mailbox-page/mailbox-page.component.ts